<template>
  <div>
    <div class="content">
      <LoginLogo />

      <div>
        <p>Thank you for registering a free trial! Check your mailbox for your verification link.</p>
      </div>

      <div class="text-center mt-5">
        <v-btn to="/account/login" block color="primary">Go to the login page</v-btn>
      </div>

    </div>

  </div>
</template>

<script>
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: 'AccountLogin',
  components: {
    LoginLogo,
  },
}
</script>

<style>
</style>
